import React from "react";
import { alertBaseClasses, alertToneClasses } from "../styles/componentClasses";

interface AlertMessageProps {
    type: "error" | "success";
    message: string | null;
    className?: string;
}

export function AlertMessage({ type, message, className = "" }: AlertMessageProps) {
    if (!message) return null;

    return (
        <div className={`${alertBaseClasses} ${alertToneClasses[type]} ${className}`}>
            {message}
        </div>
    );
}
